import React from "react";
import { Card, CardContent, Typography, Link } from "@mui/material";

function Profile() {
  const owner = {
    name: "Syed Shafiq",
    phone: "+91 7676867700",
    locationUrl: "https://maps.app.goo.gl/znntWMiB6NWZmNKp7",
  };

  return (
    <Card sx={{ maxWidth: 400, margin: "20px auto", textAlign: "center", padding: 2 }}>
      <CardContent>
        <Typography variant="h5" fontWeight="bold">
          {owner.name}
        </Typography>
        <Typography variant="body1" sx={{ color: "gray", marginY: 1 }}>
          📞 {owner.phone}
        </Typography>
        <Link
          href={owner.locationUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "blue", fontSize: "16px", textDecoration: "none" }}
        >
          📍 View Location
        </Link>
      </CardContent>
    </Card>
  );
}

export default Profile;
